var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRubyOnRails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217.22 217.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:rgba(255,255,255,.44);stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{fill:#fefefe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.72,108.56c.01,59.22-47.98,107.21-107.17,107.16-59.19-.05-107.18-48.15-107.05-107.3C1.62,49.37,49.67,1.45,108.69,1.5c59.07,.06,107.02,48.01,107.03,107.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.87,123.48H26.35c1.2-8.25,4.01-15.86,7.77-23.15,5.2-10.08,12.36-18.45,21.67-25.01,10.2-7.19,21.24-9.08,33.27-5.85,10.89,2.92,25.31,11.25,31.55,19.16-.88-.2-1.91-.16-2.6-.63-5.32-3.65-10.9-6.72-17.12-8.58-20.23-6.04-39.02,6.44-40.95,27.46-.5,5.45-.08,10.98-.08,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.29,114.23c.55-.28,.86-.46,1.18-.6,4.53-1.94,6.67-5.74,6.17-10.95-.46-4.93-3.33-8.85-8.08-9.31-5.69-.56-11.48-.14-17.19-.14v30.25h8.16v-6.32c1.96,1.74,3.84,3.47,5.78,5.12,.64,.54,1.43,1.23,2.17,1.25,3.54,.13,7.08,.06,10.61,.06,.15-.24,.29-.49,.43-.73-3.05-2.85-6.1-5.71-9.23-8.63Zm-2.11-7.92c-2.24,1.02-4.82,1.3-7.54,1.92v-7.65c2.64,.69,5.64-1.32,7.51,1.41,.71,1.05,.6,4.06,.03,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.24,101.13c-.03-4.58-3.03-7.76-7.6-8.01-3.02-.17-6.07-.14-9.09,0-4.16,.18-7.39,3.1-7.51,7.26-.21,7.64-.06,15.3-.06,23.02h8.34v-5.01h7.95v5.05h7.99c0-7.54,.04-14.93-.02-22.31Zm-8.11,8.3h-7.94c0-2.37-.16-4.66,.1-6.9,.08-.75,1.13-1.73,1.92-1.98,1.14-.35,2.56-.42,3.66-.04,.91,.32,2.03,1.4,2.16,2.27,.32,2.08,.1,4.23,.1,6.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.92,100.91v3.6c1.95,0,3.86-.02,5.77,0,6.37,.07,9.28,3.15,9.23,9.72-.05,6.3-3.08,9.35-9.33,9.36-4.17,0-8.34,0-12.63,0v-7.86h14.03v-3.84c-2.27,0-4.48,.08-6.67-.02-4.81-.21-7.82-3.51-7.95-8.6-.15-5.89,2.65-9.85,7.55-10.12,4.51-.24,9.05-.05,13.72-.05v7.8h-13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.56,123.39v-30.18h8.53v22.34h11.72v7.84h-20.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.77,123.48h-8.52v-30.3h8.52v30.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.36,102.85c-.74,1.77-1.39,3.31-2.14,5.1-1.6-.58-3.12-1.13-4.94-1.78,.72-1.72,1.38-3.3,2.16-5.16,1.7,.64,3.3,1.23,4.93,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.77,115.2c4.92,1.61,4.56,.11,5.23,6.63-4.94-.84-5.14-1.09-5.23-6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.59,106.49q-3.61-2.57-1.99-6.73c3.41,1.63,3.42,1.66,1.99,6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.4,83.55c-1.03,1.19-1.88,2.18-2.91,3.37l-3.41-2.88,3.27-3.13c1.02,.88,1.94,1.67,3.05,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.75,67.76l1.92,3-3.24,1.82-2-2.93,3.32-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.19,87.27l1.91,2.87c-.8,.97-1.53,1.85-2.47,3-.71-1.03-1.33-1.94-2.05-2.99,.85-.93,1.65-1.82,2.62-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.26,85.02c-.34-1.12-.59-1.96-.89-2.96,1.24-.46,2.37-.88,3.63-1.35,.36,.99,.66,1.79,1,2.74-1.24,.52-2.35,.99-3.74,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.13,70.46c-1.43-.54-2.67-1-3.91-1.47v-2.41c3.76,.15,4.29,.65,3.91,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.24,79.6c1.49,.23,2.71,.42,4.02,.62v2.59l-4.17-.53c.05-.89,.1-1.71,.16-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.79,63.77c1.41-.07,2.54-.12,3.87-.18,.3,.78,.6,1.55,.99,2.56-2.01-.14-4.4,1.38-4.86-2.38Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyOnRails);
export default __webpack_public_path__ + "static/media/ruby-on-rails.8638dc8985171e91b74e986b0d61c6ff.svg";
export { ForwardRef as ReactComponent };